var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLoginMailError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_login_mail_error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-1",
    transform: "translate(-1060.000000, -926.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_login_mail_error",
    transform: "translate(1057.000000, 921.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Depth",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,7 L5,17 L19,17 L19,7 L5,7 Z M19,5 C20.1,5 21,5.9 21,7 L21,17 C21,18.1 20.1,19 19,19 L5,19 C3.9,19 3,18.1 3,17 L3,7 C3,5.9 3.9,5 5,5 L19,5 Z",
    id: "Fill-1",
    fill: "#C60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4971862,6.5 L11.1690764,12.1719288 C11.6065235,12.6093571 12.3145668,12.6093571 12.752014,12.1719288 L18.4241862,6.5 L20.796806,6.50033179 C20.6481497,6.94046662 20.3984798,7.35395534 20.0477963,7.70464391 L14.1664049,13.5861203 C12.9479161,14.8046266 10.9725504,14.8046266 9.75614105,13.5861203 L3.87370996,7.70464391 C3.5228257,7.35405397 3.27298445,6.94069922 3.1241862,6.50070318 L5.4971862,6.5 Z",
    id: "Combined-Shape",
    fill: "#C60000"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginMailError);
export default __webpack_public_path__ + "static/media/icon_login_mail_error.71762ea199b8c07855b49853f0182c3f.svg";
export { ForwardRef as ReactComponent };